// src/app/helpers/routePermissions.js
import React from 'react';
import { Redirect } from 'react-router-dom/';
import { ACCESS, ROLES } from '../constants/permissions/roles';
import platforms from '../constants/users/platforms';
import { checkPermissions, getDefaultFallbackPath } from './PermissionsChecker';

export const getInitialRoute = (user) => {
    if (!user?.roles?.length) {
        return '/login';
    }

    const userRole = user.roles.find(r => r.role.id_platform === platforms.backoffice);
    if (!userRole) {
        return '/login';
    }

    const roleId = userRole.role.id;

    const roleRoutes = {
        [ROLES.admin]: '/clients', // Administrator goes to clients
        [ROLES.operator]: '/clients', // Operator goes to clients
        [ROLES.externalSupport]: '/managment/consultants', // External support goes to consultants
        [ROLES.fraudPrevention]: '/managment/fraudPrevention',
        [ROLES.fraudPreventionAdmin]: '/managment/fraudPrevention',
        [ROLES.customer]: '/login' // Customer should not access the backoffice
    };

    const hasAccess = (roleId) => {
        if (ACCESS.ALL.includes(roleId)) {
            return true;
        }

        if (ACCESS.INTERNAL.includes(roleId)) {
            return true;
        }

        if (ACCESS.EXTERNAL.includes(roleId)) {
            return true;
        }

        if (ACCESS.FRAUD_PREVENTION.includes(roleId)) {
            return true;
        }

        return false;
    };

    const initialRoute = roleRoutes[roleId] || '/login';

    if (!hasAccess(roleId)) {
        return '/login';
    }

    return initialRoute;
};

export function handleRouteAccess ({
    Component,
    isPageEnabled = true,
    action,
    history,
    fallbackPath = '/clients'
}) {
    const resultingComponent = redirectOnUnauthorized(action, history);
    const resultingComponent2 = redirectOnNotEnabled(isPageEnabled, history);

    // If the user is not authorized or the page is not enabled, redirect to the fallback path
    // Otherwise, render the component
    return resultingComponent || resultingComponent2 || <Component />;
}

const redirectOnUnauthorized = (action, history) => {
    const hasAccess = checkPermissions(action);

    if (!hasAccess) {
        const fallbackPath = getDefaultFallbackPath();
        return <Redirect to={fallbackPath} />;
    }
};

const redirectOnNotEnabled = (isPageEnabled, history) => {
    if (!isPageEnabled) {
        const fallbackPath = getDefaultFallbackPath();
        return <Redirect to={fallbackPath} />;
    }
};
